import { supabase } from "../../config/supabase";

// Remove a course
const removeCourse = async (courseId) => {
    try {
        const { error } = await supabase.from('courses').delete().eq('course_id', courseId);
        if (error) throw new Error(error);
        return { error: null };
    } catch (err) {
        console.log('an error in deleting courses:',err);
        return { error: err };
    }
};

export { removeCourse };